import { useQuery } from '@tanstack/react-query';
import { useAccounts } from '../accounts/AccountsContext';
import { useApi } from '../shared/api-client/ApiClientProvider';

export function useInteractions(options?: { withDeleted?: boolean }) {
  const { currentAccount } = useAccounts();
  const { profileApi } = useApi();
  const accountId = currentAccount?.id;
  const withDeleted = options?.withDeleted ?? false;

  return useQuery({
    queryKey: ['interactions', accountId, withDeleted],
    queryFn: () =>
      profileApi.listInteractions(accountId!, {
        params: { withDeleted },
      }),
    enabled: !!accountId,
    placeholderData: [],
  });
}
